export const SIGNUP_ENCRYPT_API_KEY_PREFIX = 'Jerry-Signup-Encrypt-Key';
